<template>
  <div>
    <!-- <button class="btn btn-primary" @click="email()">Email</button> -->
    <div class="pt-3 pl-3 pb-2" style="background-color: var(--bootstrapgrey); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h3 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000;">Coach's Dashboard</h3>
    </div>

    <!-- {{ team }} -->

    <!-- -------- FILTERS ------- -->
    <div class="accordion sticky-top mt-2 filters" :class="{ myrundash: !team || team == 'myrundash', MDI: team == 'MDI', Ryerson: team == 'Ryerson', JKR: team == 'JKR' }" style="padding-top: 5px; padding-bottom: 5px;">
      <div class="header" style="padding-left: 12px;" v-on:click="filtersVisible = !filtersVisible">
        <slot name="header">Filters</slot>
      </div>
      <!-- {{team}} -->
      <transition name="accordion"
        v-on:before-enter="beforeEnter" v-on:enter="enter"
        v-on:before-leave="beforeLeave" v-on:leave="leave">
        <div class="body" v-show="filtersVisible">
          <div class="body-inner" style="padding-top: 0; padding-bottom: 15px;">
            <div class="row">
              <div class="col-lg-3 pr-4">
                <label>Status</label>
                <select class="form-control" v-model="statusFilter">
                  <option>All</option>
                  <option v-for="(status, index) in statuses" :key="'StatusFilter'+index">{{ status }}</option>
                </select>
                <label>Payment Status</label>
                <select class="form-control" v-model="paymentStatusFilter">
                  <option>All</option>
                  <option v-for="(status, index) in paymentStatuses" :key="'PaymentStatusFilter'+index">{{ status }}</option>
                </select>

                <!-- <label for="">Disponibilidad</label>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="Día" id="Día" v-model="availabilityFilter">
                  <label class="form-check-label" for="Día">
                    Día
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="Noche" id="Noche" v-model="availabilityFilter">
                  <label class="form-check-label" for="Noche">
                    Noche
                  </label>
                </div> -->
              </div>
              <div class="col-lg-3 pr-4">
                <label>Winter/Spring Group</label>
                <select class="form-control" v-model="categoryFilter">
                  <option>All</option>
                  <option v-for="(category, index) in categories" :key="index">{{ category }}</option>
                </select>
                <label>Summer/Fall Group</label>
                <select class="form-control" v-model="category2Filter">
                  <option>All</option>
                  <option v-for="(category, index) in categories2" :key="index">{{ category }}</option>
                </select>
              </div>
              <div class="col-lg-3 pr-4 mt-2 ml-3">
                <div>
                  <input class="form-check-input" type="checkbox" v-model="sortByLastName">
                  <label class="form-check-label" style="margin-top: 0">Sort By Last Name</label>
                </div>
                <div>
                  <input class="form-check-input" type="checkbox" v-model="sortByDate">
                  <label class="form-check-label" style="margin-top: 0">Sort By Date</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- -------- END OF FILTERS ------- -->

    <input type="text" class="form-control" v-model="searchBar" placeholder="Search by name or email">

    <p class="mt-3 ml-1">Total Runners: {{ filteredRunners.length }}</p>

    <!-- It would be nice to freeze the table's header row, but apparently it's not simple -->
    <!-- https://stackoverflow.com/questions/8423768/freeze-the-top-row-for-an-html-table-only-fixed-table-header-scrolling -->
    <table class="table table-striped">
      <thead class="" style="color: #fff;" :class="{ myrundash: !team || team == 'myrundash' || team == 'Demo', MDI: team == 'MDI', Ryerson: team == 'Ryerson', JKR: team == 'JKR' }">
        <tr class="">
          <th scope="col">Name</th>
          <th scope="col">Status</th>
          <th scope="col">Payment</th>
          <th scope="col">Updated</th>
          <th scope="col">Email</th>
          <th scope="col">Cell</th>
          <th scope="col">Spring Group</th>
          <th scope="col">Fall Group</th>
          <!-- <th scope="col">Group</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="runner in filteredRunners" :key="runner.id" @click="showUserModal(runner)" style="cursor: pointer;">
          <td>
            {{ runner.first_name }} {{ runner.last_name }}
          </td>
          <!-- Only want to show the status dropdown for the particular runner that was clicked on -->
          <!-- <td @click="editStatus(runner)" style="cursor: pointer;">
            <span v-if="!editing">{{ runner.status }}</span>
            <span v-if="editing && (runner.id != user.id)">{{ runner.status }}</span>
            <div class="row" v-if="editing && (runner.id == user.id)">
              <div class="col-lg-8">
                <select class="form-control" id="" v-model="status">
                  <option v-for="(status, index) in statuses" :key="index">{{ status }}</option>
                </select>
              </div>
              <div class="col-lg-4" style="padding-left: 0;">
                <button class="btn btn-success" style="padding: 0.35rem 0.75rem;" @click="saveStatus(runner)">SAVE</button>
              </div>
            </div>
          </td> -->
          <td>
            {{ runner.status }}
          </td>
          <td>
            {{ runner.payment_status }}
          </td>
          <td>
            <!-- Make the last updated date better formatted for humans -->
            <!-- https://stackoverflow.com/questions/1168807/how-can-i-add-a-key-value-pair-to-a-javascript-object -->
            {{ new Date(runner.last_updated_date).toDateString() }}
          </td>
          <td>
            {{ runner.email }}
          </td>
          <td>
            {{ runner.cell_phone }}
          </td>
          <!-- <td @click="editGroup(runner)" style="cursor: pointer;">
            <span v-if="!editing">{{ runner.group }}</span> -->
            <!-- Only want to show the group dropdown for the particular runner that was clicked on -->
            <!-- <span v-if="editing && (runner.id != user.id)">{{ runner.group }}</span>
            <div class="row" v-if="editing && (runner.id == user.id)">
              <div class="col-lg-8">
                <select class="form-control" id="" v-model="group">
                  <option v-for="(group, index) in groups" :key="index">{{ group }}</option>
                </select>
              </div>
              <div class="col-lg-4" style="padding-left: 0;">
                <button class="btn btn-success" style="padding: 0.35rem 0.75rem;" @click="saveGroup(runner)">SAVE</button>
              </div>
            </div>
          </td> -->
          <td>
            <p v-for="(category, index) in runner.categories" :key="index">{{ category }}</p>
          </td>
          <td>
            <p v-for="(category, index) in runner.categories2" :key="index">{{ category }}</p>
          </td>
        </tr>
      </tbody>
    </table>

    <modal name="user-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 99999;">
      <div class="p-4">
        <div class="row px-4 mb-4" style="">
          <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'userprofile' }" @click="tab = 'userprofile'">
            RUNNER PROFILE
          </div>
          <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'runnerdashboard' }" @click="tab = 'runnerdashboard'">
            RUNNER DASHBOARD
          </div>
          <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'traininglog' }" @click="tab = 'traininglog'">
            TRAINING LOG
          </div>
          <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'pastraces' }" @click="tab = 'pastraces'">
            PAST RACES
          </div>
        </div>

        <div v-if="tab == 'userprofile'" class="px-3">
          <div class="mx-2 user-profile">
            <h3 class="section-header">Coach's Info</h3>
            <div v-if="!editCoach">
              <label v-if="user.status">Status</label>
              <p class="profile-element">{{ user.status }}</p>
              <label v-if="user.payment_status">Payment Status</label>
              <p class="profile-element">{{ user.payment_status }}</p>
              <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="editCoachInfo()">Edit Coach's Info</button>
              <hr>
            </div>
            <div v-if="editCoach">
              <label>Status</label>
              <select class="form-control" v-model="status">
                <option v-for="(status, index) in statuses" :key="'StatusEdit'+index">{{ status }}</option>
              </select>
              <label>Payment Status</label>
              <select class="form-control" v-model="paymentStatus">
                <option v-for="(status, index) in paymentStatuses" :key="'PaymentStatusEdit'+index">{{ status }}</option>
              </select>
              <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="saveCoachInfo()">Save Coach's Info</button>
              <hr>
            </div>
          </div>

          <div v-if="!editing">
            <button class="btn btn-primary mt-3 ml-2" style="display: block;" @click.prevent="editProfile()">Edit Runner Profile</button>
            <app-user-profile-info :user="user"></app-user-profile-info>
            <button v-if="user.first_name" class="btn btn-primary mt-3 ml-2" style="" @click.prevent="editProfile()">Edit Runner Profile</button>
            <button class="btn btn-danger mt-3 mb-4 mr-2" style="float: right;" @click.prevent="showDeleteModal(user)">Delete</button>
          </div>
          <div v-if="editing">
            <app-user-profile-edit :user="user" @profileSaved="profileSaved()"></app-user-profile-edit>
          </div>
        </div>

        <div v-if="tab == 'runnerdashboard'" class="px-3">
          <app-runner-dashboard :userID="user.id"></app-runner-dashboard>
        </div>

        <div v-if="tab == 'traininglog'" class="px-3">
          <app-training-plan :userID="user.id"></app-training-plan>
        </div>

        <div v-if="tab == 'pastraces'" class="px-3">
          <app-race-log :userID="user.id"></app-race-log>
        </div>

      </div>
    </modal>

    <!-- Modal to confirm deletion of a user -->
    <div v-if="user">
      <modal name="delete-modal" width="85%" height="auto" :scrollable='true' class="" style="z-index: 99999;">
        <div class="p-4">
          <h4>Are you sure you want to delete: {{ user.email }}?</h4>
          <hr>
          <button class="btn btn-danger mb-2" @click="deleteUser(user.id)">Delete</button>
          <button class="btn btn-info mb-2" @click="hideDeleteModal()">Cancel</button>
        </div>
      </modal>
    </div>

    <!-- {{ users }} -->
  </div>
</template>

<script>
  import axios from 'axios'

  import UserProfileInfo from '../../UserProfileInfo.vue'
  import UserProfileEdit from '../../UserProfileEdit.vue'
  import RunnerDashboard from '../dashboard/Dashboard.vue'
  import TrainingPlan from '../TrainingPlan.vue'
  import RaceLog from '../RaceLog.vue'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    components: {
      appUserProfileInfo: UserProfileInfo,
      appUserProfileEdit: UserProfileEdit,
      appRunnerDashboard: RunnerDashboard,
      appTrainingPlan: TrainingPlan,
      appRaceLog: RaceLog,
    },
    data() {
      return {
        users: [],
        user: {},
        status: '',
        statuses: ['Profile Incomplete', 'Training Plan Pending', 'Training Plan Complete', 'Requested Race Plan', 'Injured', 'No Longer With Team'],
        statusFilter: 'All',
        group: '',
        groups: ['Mississauga Stadium', 'High Park', 'Monarch Park AM', 'Monarch Park PM'],
        groupFilter: 'All',
        categoryFilter: 'All',
        categories: [],
        category2Filter: 'All',
        categories2: [],
        paymentStatus: '',
        paymentStatuses: [],
        paymentStatusFilter: 'All',

        // team: '',

        sortByLastName: false,
        sortByDate: false,

        editing: false,
        editCoach: false,
        filtersVisible: false,

        aakashid: null,

        tab: 'userprofile',

        searchBar: '',
      }
    },
    created () {
      this.getUserData();
      // this.team = this.$store.getters.team
      this.categories = this.$store.getters.MDIwinterspringCategories
      this.categories2 = this.$store.getters.MDIsummerfallCategories
      this.paymentStatuses = this.$store.getters.paymentStatuses

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },2500)
    },
    computed: {
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      },
      // activetab () {
      //   return this.$store.getters.menuState
      // }
      team () {
        if (this.$store.getters.team) {
          return this.$store.getters.team
        }
        else {
          return ''
        }
      },
      isCoach () {
        return this.$store.getters.isCoach
      },
      filteredRunners () {
        var statusFilteredRunners = []
        if (this.statusFilter != 'All') {
          for (var user in this.users) {
            if (this.users[user].status == this.statusFilter) {
              statusFilteredRunners.push(this.users[user])
            }
          }
        }
        else {
          statusFilteredRunners = this.users
        }

        var groupFilteredRunners = []
        if (this.groupFilter != 'All') {
          for (var user in statusFilteredRunners) {
            if (statusFilteredRunners[user].group == this.groupFilter) {
              groupFilteredRunners.push(statusFilteredRunners[user])
            }
          }
        }
        else {
          groupFilteredRunners = statusFilteredRunners
        }

        var categoryFilteredRunners = []
        if (this.categoryFilter != 'All') {
          for (var user in groupFilteredRunners) {
            if (groupFilteredRunners[user].categories.includes(this.categoryFilter)) {
              categoryFilteredRunners.push(groupFilteredRunners[user])
            }
          }
        }
        else {
          categoryFilteredRunners = groupFilteredRunners
        }

        var category2FilteredRunners = []
        if (this.category2Filter != 'All') {
          for (var user in categoryFilteredRunners) {
            if (categoryFilteredRunners[user].categories2.includes(this.category2Filter)) {
              category2FilteredRunners.push(categoryFilteredRunners[user])
            }
          }
        }
        else {
          category2FilteredRunners = categoryFilteredRunners
        }

        if (this.sortByLastName) {
          // https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/
          // https://stackoverflow.com/questions/2466356/javascript-object-list-sorting-by-object-property
          // https://stackoverflow.com/questions/6712034/sort-array-by-firstname-alphabetically-in-javascript
          category2FilteredRunners = category2FilteredRunners.sort((a, b) => ((a.last_name.toUpperCase()) > (b.last_name.toUpperCase())) ? 1 : -1)
          // https://www.w3schools.com/jsref/jsref_touppercase.asp - Upper and lower case letters were being ordered differently, need to convert first to keep consistency
        }

        if (this.sortByDate) {
          category2FilteredRunners = category2FilteredRunners.sort((a, b) => (a.last_updated_date > b.last_updated_date) ? 1 : -1)
        }

        var paymentStatusFilteredRunners = []
        if (this.paymentStatusFilter != 'All') {
          for (var user in category2FilteredRunners) {
            if (category2FilteredRunners[user].payment_status == this.paymentStatusFilter) {
              paymentStatusFilteredRunners.push(category2FilteredRunners[user])
            }
          }
        }
        else {
          paymentStatusFilteredRunners = category2FilteredRunners
        }

        if (this.searchBar) {
          paymentStatusFilteredRunners = paymentStatusFilteredRunners.filter(runner => {
            return (runner.first_name + ' ' + runner.last_name + ' ' + runner.email).toLowerCase().includes(this.searchBar.toLowerCase())
          })
        }

        // return this.users
        return paymentStatusFilteredRunners
      },
    },
    methods: {
      getUserData() {
        axios.get('/api/users/?team='+this.team+'&is_coach=false',
          // {
          //   headers: {
          //     'Authorization': 'Token 26a82d24df3a2af06a22a0f1d96aae1b3a359719'
          //   }
          // }
        )
          .then(res => {
            this.users = res.data

            // this.users = this.users.sort((a, b) => (a.last_name[0] > b.last_name[0]) ? 1 : -1)
            // this.users = this.users.sort((a, b) => (a.last_updated_date > b.last_updated_date) ? 1 : -1)
          })
          .catch(error => console.log(error))
      },
      showUserModal(user) {
        this.user = user
        this.status = user.status
        this.paymentStatus = user.payment_status

        this.tab = 'userprofile'

        // This was meant to only open the modal if the person had at least entered their name. Scrapped this because it's confusing
        // if (user.first_name) {
        //   this.$modal.show('user-modal')
        // }
        this.editing = false // If coach opens someone's profile, clicks Edit and then closes the modal without saving, need to make sure the next one he opens is not in edit mode
        this.$modal.show('user-modal')
      },
      hideUserModal() {
        this.$modal.hide('user-modal')
      },
      editStatus(user) {
        this.user = user
        this.status = user.status
        this.editing = true
      },
      saveStatus(user) {
        axios.patch('/api/users/'.concat(user.id.toString())+'/',
          {
            status: this.status
          }
        )
          .then(res => {
            this.users = res.data
            this.editing = false
            this.getUserData()
          })
          .catch(error => console.log(error))
      },
      editGroup(user) {
        this.user = user
        this.group = user.group
        this.editing = true
      },
      saveGroup(user) {
        axios.patch('/api/users/'.concat(user.id.toString())+'/',
          {
            group: this.group
          }
        )
          .then(res => {
            this.users = res.data
            this.editing = false
            this.getUserData()
          })
          .catch(error => console.log(error))
      },

      // This is the method used when coach clicks edit on a runner's proile modal
      editProfile() {
        this.editing = true

        // Scroll the window back up to edit profile
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      },
      editCoachInfo() {
        this.editCoach = true
      },
      saveCoachInfo() {
        axios.patch('/api/users/'.concat(this.user.id.toString()).concat('/'),
          {
            status: this.status,
            payment_status: this.paymentStatus,
          }
        )
          .then(res => {
            this.editCoach = false
            this.user.status = this.status
            this.user.payment_status = this.paymentStatus
            this.getUserData()
          })
          .catch(error => {
            console.log(error)
          })
      },
      // This is the method when coach clicks Save on a runner's profile
      profileSaved() {
        console.log('Profile Saved')
        // this.getUserProfile()
        this.editing = false
        this.hideUserModal()
        this.getUserData()
      },

      deleteUser(userID) {
        console.log('Deleting User: '.concat(userID.toString()))

        axios.delete('/api/users/'.concat(userID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            this.getUserData()
            this.hideDeleteModal()
            this.hideUserModal()
          })
          .catch(error => console.log(error))
      },
      showDeleteModal(user) {
        this.$modal.show('delete-modal')
      },
      hideDeleteModal(user) {
        this.$modal.hide('delete-modal')
      },

      /* ---- Accordion methods --- */
      beforeEnter: function(el) {
        el.style.height = '0';
      },
      enter: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      beforeLeave: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      leave: function(el) {
        el.style.height = '0';
      },
      /* ---- End of Accordion methods --- */

      email() {
        // Get the id of the aakashkgoel@gmail.com user
        // this is necessary because the user changes depending on whether we are using the dev or production database
        axios.get('/api/users/?email=aakashkgoel@gmail.com')
          .then(res => {
            console.log('Getting aakashid')
            console.log(res)
            console.log(res.data)
            console.log(res.data[0].id)
            this.aakashid = res.data[0].id

            // Send myself an email notification that a new candidate registered
            this.$store.dispatch('sendEmail',
              {
                subject: 'Alive!',
                message: 'this.nuevoMessage',
                from: 'info@myrundash.com',
                email: 'aakashkgoel@gmail.com',
                reply: 'aakashkgoel@gmail.com',
                userID: this.aakashid,
              }
            )
          })
          .catch(error => console.log(error))
      },
    }
  }
</script>

<style>
  .filters label {
    font-weight: 700;
    margin-bottom: 3px;
    margin-top: 10px;
    color: #2F4F4F;
  }
</style>



// WEBPACK FOOTER //
// src/components/myrundash/coach/Dashboard.vue